<template>
  <v-container grid-list-md>
    <bread-crump-partial header="Service &amp; Wartung"></bread-crump-partial>
    <v-layout row wrap>
      <v-flex xs12 sm8 md8>
        <p>
          <strong>
            Gerne betreuen wir die Projekte unserer Kunden auch über die Vertragsdauer hinaus. Hierbei stehen wir Ihnen mit Rat und Tat
            zur Seite und geben Interessante Impulse für mögliche Weiterentwicklungen.
          </strong>
        </p>
        <p>
          Für eine optimale Nutzung unser Lösungen bieten wir auch Schulungen an, die es den Anwendern ermöglichen alle Funktionen
          effizient einzusetzen. Neben den Schulungen sind auch Workshops zur Auffrischung der Kenntnisse Bestandteil unseres
          Leistungsangebotes.
        </p>
        <br />
        <br />
        <accordion :panels="panelItems">Leistungsfelder:</accordion>
      </v-flex>
      <v-flex xs12 sm4 md4>
        <contact-widget></contact-widget>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BreadCrumpPartial from './partials/BreadCrumpPartial'
  import Accordion from './widgets/AccordionWidget'
  import ContactWidget from './widgets/ContactWidget'

  export default {
    name: 'ServicePage',
    components: {
      BreadCrumpPartial,
      Accordion,
      ContactWidget
    },
    data () {
      return {
        name: 'ConsultingPage',
        panelItems: [{
          icon: 'local_offer',
          color: 'yellow accent-4',
          title: 'Dokumentenmanagment',
          text: ' Datenbankgestütze Vorlagenmanagment für MS Word mit vorgegebenen Benneung und Ablage ist effektive und schnelle Kundenkorrespondez unerlässlich. Seit über 25 Jahren entwicklen wir hierfür angepasste Lösungen.  '
        },
        {
          icon: 'local_offer',
          color: 'yellow accent-4',
          title: 'Reportingsysteme',
          text: 'Datenbank gestützte Reportingsysteme basierend auf Webtechnologie und MS Excel gehören zu unseren Stärken. Oft in Kombination mit modersten Auswertungstechniken wie <abbr>Bigdata</abbr> oder ElasticSearch ergeben viele neue Einsichten in die Daten ihrer Projekte. '
        },
        {
          icon: 'local_offer',
          color: 'yellow accent-4',
          title: 'Server (Netzwerk, Skalierbarkeit)',
          text: 'Spielt eigentlich nur noch bei Inhouse-Hosting eine grosse Rolle. Bei Cloudhosting ist die Skalierbeit und Vernnetzung als Teil der Lösung schon vorhanden.'
        },
        {
          icon: 'local_offer',
          color: 'yellow accent-4',
          title: 'Monitoring',
          text: 'Gerade bei verteilten Lösungen ist ein detailiertes Monitoring und Loggin für einen sicheren Betrieb der Soft- und Hardware unabdingbar.'
        }
        ]

      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/ServicePage.vue